import { render } from "./index.vue?vue&type=template&id=d552604e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d552604e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d552604e"

export default script